
import * as Components from "./Tanghuo"

export default function getCustomComponent () {
  return Components
}

export function getShopId () {
  return "tanghuo"
}

